import { render, staticRenderFns } from "./CategoryHandlingFeesForm.vue?vue&type=template&id=1f9b72b3"
import script from "./CategoryHandlingFeesForm.vue?vue&type=script&lang=js"
export * from "./CategoryHandlingFeesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports